import { render, staticRenderFns } from "./RequestTaxi.vue?vue&type=template&id=183f4f6d&"
import script from "./RequestTaxi.vue?vue&type=script&lang=js&"
export * from "./RequestTaxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports